export enum CodStatus {
    SUBMITTED = 'Submitted',
    INVESTIGATION = 'Investigation',
    CREDIT_REVIEW = 'Credit_Review',
    MANAGER_REVIEW = 'Manager_Review',
    FINANCE_REVIEW = 'Finance_Review',
    CLOSED = 'Closed'
}
